<a
  class="flex hs-4"
  [attr.href]="href || null"
  [class.c-pointer]="!!href || !!routerLink"
  [class.hoverable]="!!href || !!routerLink"
>
  <ng-content></ng-content>
</a>
